import React from 'react';
import { useNavigate } from 'react-router-dom';

import Img1 from '../../img/products/equiposDePresion/EquiposPresionConstante/PresionConstante1.png';
import Img2 from '../../img/products/equiposDePresion/EquiposPresionConstante/PresionConstante2.png';

const EquiposDePresionConstante = () => {
  const navigate = useNavigate();

  return (
    <div className="container my-5">
      <h2 className="mb-4 text-center">Equipos de Presion Constante y Velocidad Variable</h2>

      {/* Estilos inline o puedes mover esto a tu CSS */}
      <style>{`
        .img-hover-zoom {
          transition: transform 0.3s ease;
        }

        .img-hover-zoom:hover {
          transform: scale(1.05);
        }
      `}</style>

      <div className="row align-items-start mb-2">
        {/* Columna Izquierda: texto descriptivo */}
        <div className="col-md-7">
          <p className="lead text-justify">
            Los equipos de presión constante y velocidad variable son sistemas de bombeo diseñados para 
            mantener una presión uniforme en una red de distribución de agua, independientemente de las 
            variaciones en el caudal y la presión de entrada industriales.
          </p>
          <p className="lead text-justify">
            Cada bomba está equipada con un variador de frecuencia que ajusta la velocidad de la bomba 
            según la demanda de agua. Detecta la caída de presión en la red y activa las bombas para 
            mantener una presión constante. Puede incluir una o varias bombas que trabajan en conjunto 
            para compensar las variaciones de presión.
          </p>
        </div>
        {/* Columna derecha: imágenes en cuadrícula */}
        <div className="col-md-5">
          <div className="row g-4">
            <div className="col-5">
              <img src={Img1} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Presion 1" />
            </div>
            <div className="col-5">
              <img src={Img2} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Presion 2" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EquiposDePresionConstante;
